<template>
  <section class="invoice-preview-wrapper">

    <b-row v-if="userEvaluation" class="invoice-preview">
      <b-col cols="12" xl="12" md="12">

        <app-collapse type="default">

          <b-card-body class="p-0"  v-for="(componentSection, idx) in componentSections"
                       :key="idx">

            <div v-if="idx !== 0">
              <app-collapse-item
                  :title=" componentSection.section.title"
                  :is-visible="idx === 1"
              >

                <b-col cols="12">
                  <small v-if="componentSection.section.coef" class="text-muted">Coef : {{
                      componentSection.section.coef
                    }} %</small>
                  <small class="text-muted">{{ componentSection.section.description }}</small>
                </b-col>

                <b-col v-if="isStandard(componentSection.section.position)" cols="12">
                  <b-table-simple hover small caption-top responsive>
                    <colgroup>
                      <col style="width: 300px;">
                      <col style="width: 150px;" span="8">
                    </colgroup>


                    <template v-for="(content, contentk) in componentSection.content">

                      <b-tbody :key="'content-tbody-' + contentk">
                        <b-tr v-for="(contentSection, k) in content.contentSections" :key="'row-' + contentk + '-' + k">

                          <b-th colspan="1">{{ contentSection.titre }}</b-th>

                          <template v-if="content.contentSections.length === 1">
                            <b-th colspan="8" v-for="(value, index) in contentSection.valueComponentModels"
                                  :key="'value-auto-' + contentk + '-' + k + '-' + index">
                              <template v-if="Array.isArray(value)">
                                <ol>
                                  <li v-for="(item, subIndex) in value" :key="'item-' + subIndex">{{ item }}</li>
                                </ol>
                              </template>
                              <template v-else>
                                <span>{{ value }}</span>
                              </template>
                            </b-th>
                          </template>
                          <template v-else>
                            <b-th v-for="(value, index) in contentSection.valueComponentModels"
                                  :key="'value-auto-' + contentk + '-' + k + '-' + index" :colspan="2">
                              <template v-if="Array.isArray(value)">
                                <ol>
                                  <li v-for="(item, subIndex) in value" :key="'item-' + subIndex">{{ item }}</li>
                                </ol>
                              </template>

                              <template v-if="!isNaN(value)">
                                <span class="d-block text-center">{{ value }}</span>
                              </template>

                              <template v-else>
                                <span>{{ value }}</span>
                              </template>
                            </b-th>
                          </template>

                        </b-tr>
                      </b-tbody>
                    </template>


                  </b-table-simple>

                </b-col>

                <b-col v-if="!isStandard(componentSection.section.position)" cols="12">
                  <b-table-simple hover small caption-top responsive>
                    <colgroup>
                      <col style="width: 300px;">
                      <col style="width: 150px;" span="8">
                    </colgroup>


                    <template v-for="(content, contentk) in componentSection.content">
                      <b-thead head-variant="light" :key="'content-thead-' + contentk">
                        <b-tr :key="'content-titles-' + contentk">
                          <b-th colspan="2"></b-th>

                          <template v-if="content.contentSections.length === 1">
                            <b-th colspan="8" v-for="(component, j) in content.contentSections"
                                  :key="'auto-' + contentk + '-' + j" class="text-center">
                              {{ component.titre }}
                            </b-th>

                          </template>

                          <template v-else>
                            <b-th colspan="4" v-for="(component, j) in content.contentSections"
                                  :key="'auto-' + contentk + '-' + j" class="text-center">
                              {{ component.titre }}
                            </b-th>

                          </template>
                        </b-tr>
                      </b-thead>

                      <b-tbody :key="'content-tbody-' + contentk">
                        <b-tr v-for="(componentModel, k) in content.componentModels" :key="'row-' + contentk + '-' + k">
                          <b-th colspan="2" class="font-weight-bold mb-70  text-justify">
                            {{ componentModel.titre }}
                            <small v-if="componentModel.note" class="text-muted"> | {{ componentModel.note }} %</small>

                          </b-th>
                          <template v-if="content.contentSections.length === 1">
                            <b-th colspan="8" v-for="(value, index) in componentModel.valueComponentModels"
                                  :key="'value-auto-' + contentk + '-' + k + '-' + index"
                                  class="font-weight-bold mb-70  text-justify">
                              <template v-if="Array.isArray(value)">
                                <ol>
                                  <li v-for="(item, subIndex) in value" :key="'item-' + subIndex">{{ item }}</li>
                                </ol>
                              </template>

                              <template v-else-if="!isNaN(value)">
                                <span class="d-block text-center text-justify">{{ value }}</span>
                              </template>

                              <template v-else>
                                <span>{{ value }}</span>
                              </template>
                            </b-th>
                          </template>
                          <template v-else>
                            <b-th v-for="(value, index) in componentModel.valueComponentModels"
                                  :key="'value-auto-' + contentk + '-' + k + '-' + index" :colspan="4"
                                  class="font-weight-bold mb-70  text-justify">
                              <template v-if="Array.isArray(value)">
                                <ol>
                                  <li v-for="(item, subIndex) in value" :key="'item-' + subIndex">{{ item }}</li>
                                </ol>
                              </template>

                              <template v-if="!isNaN(value)">
                                <span class="d-block text-center text-justify">{{ value }}</span>
                              </template>

                              <template v-else>
                                <span>{{ value }}</span>
                              </template>
                            </b-th>
                          </template>

                        </b-tr>
                      </b-tbody>
                    </template>
                  </b-table-simple>

                </b-col>
              </app-collapse-item>
              <hr>

            </div>
          </b-card-body>

        </app-collapse>

        <hr v-if="userEvaluation.description || userEvaluation.descriptionAutomatic" title="Commentaire Validation"/>

        <b-card v-if="userEvaluation.description || userEvaluation.descriptionAutomatic" title="Commentaire Validation">
          <b-card-text class="text-danger text-justify">{{ userEvaluation.descriptionAutomatic
            }}</b-card-text>
          <b-card-text>
            {{ userEvaluation.description
            }} </b-card-text>
        </b-card>

      </b-col>

    </b-row>
  </section>
</template>

<script>
import {
  BCard,
  BCardText,
  BCol,
  BRow,
} from 'bootstrap-vue';
import router from '@/router';
import Ripple from 'vue-ripple-directive';

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import {getJsonFromStorage} from "@/util/storageUtils";
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";


export default {
  directives: {
    Ripple,
  },
  components: {
    AppCollapse,
    AppCollapseItem,
    BCardText,
    BRow, BCol, BCard,
    //eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      userData: null,

    };
  },
  watch: {

  },
  props: {
    userEvaluation: {
      type: [Object, null],
      default: null

    },
    componentSections:{
      type: Array,
      default: null
    },
    isHierarchyModifying: {
      type: Boolean,
      default: false
    },
    currentYear: {
      type: Number,
      default: null
    },
    sections: {
      type: Array,
      default: null
    }
  },
  methods: {
    showToast(variant, position, text) {
      this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'Notification',
              icon: 'InfoIcon',
              text,
              variant,
            },
          },
          { position }
      );
    },
    isStandard(sectionId) {
      const sectionData = this.sections.find(section => section.position === sectionId);
      return sectionData && sectionData.responseChoice === 'Standard';
    },

  },

  mounted() {
    this.userData = getJsonFromStorage('userData');

  },
};
</script>


<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
</style>

<style lang="scss">
@media print {

  /* CSS for printing */
  body {
    background-color: transparent !important;
  }

  nav.header-navbar {
    display: none;
  }

  .main-menu {
    display: none;
  }

  .header-navbar-shadow {
    display: none !important;
  }

  .content.app-content {
    margin-left: 0;
    padding-top: 2rem !important;
  }

  footer.footer {
    display: none;
  }

  .card {
    background-color: transparent;
    box-shadow: none;
  }

  .customizer-toggle {
    display: none !important;
  }

  /* Invoice Specific Styles */
  .invoice-preview-wrapper {
    .row.invoice-preview {
      .col-md-8 {
        max-width: 100%;
        flex-grow: 1;
      }

      .invoice-preview-card {
        .card-body:nth-of-type(2) {
          .row {
            >.col-12 {
              max-width: 50% !important;
            }

            .col-12:nth-child(2) {
              display: flex;
              align-items: flex-start;
              justify-content: flex-end;
              margin-top: 0 !important;
            }
          }
        }
      }
    }

    .invoice-actions {
      display: none;
    }
  }
}
</style>
